import { RouteRecordRaw } from 'vue-router';

const consumer: RouteRecordRaw[] = [
  {
    path: '/:i18nParamKey/account',
    name: 'Account',
    component: () => import(/* webpackChunkName: "account" */ '@/layouts/account/Account.vue'),
    redirect: (to) => {
      return {
        ...to,
        name: 'AccountSignIn',
      };
    },
    children: [
      {
        path: '/:i18nParamKey/account/sign-in',
        name: 'AccountSignIn',
        component: () =>
          import(/* webpackChunkName: "account-sign-in" */ '@/views/account/sign-in/SignIn.vue'),
      },
    ],
  },
];

export default consumer;
